import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Container, Row, Col } from "react-bootstrap";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import { yesOrNo } from "../../../../TCPForms/data";
import { TextField } from "@mui/material";

const InvitationSuggestion = ({ formData, handleTabChange, isEmployee, isApproved, onSaveClick }) => {
  const tenantId = Digit.ULBService.getStateId?.() || Digit.ULBService.getCurrentTenantId?.() || "up";
  const applicationNo = formData?.applicationNo || formData?.oldMapSubApplNumber || formData?.applicationNumber;
  const [landUseData, setLandUseData] = useState(null);

  useEffect(() => {
    const fetchLandUseData = async () => {
      if (!applicationNo) return;
      try {
        let res = await Digit.OBPSService.BPASearchFormLandUse(tenantId, { oldMapSubApplNumber: applicationNo });
        if (!res?.LandUse?.length) {
          res = await Digit.OBPSService.BPASearchFormLandUse(tenantId, { applicationNo: applicationNo });
        }
        if (res?.LandUse?.[0]) {
          setLandUseData(res.LandUse[0]);
        }
      } catch (err) {
        console.error("Error fetching Land Use search data for Invitation Suggestion:", err);
      }
    };
    fetchLandUseData();
  }, [applicationNo, tenantId]);

  const extractValues = (formSrc, landSrc) => {
    const hasSuggestion =
      formSrc?.hasSuggestion ||
      formSrc?.pressDetails?.hasSuggestion ||
      formSrc?.pressReleaseDetails?.hasSuggestion ||
      landSrc?.hasSuggestion ||
      landSrc?.pressDetails?.hasSuggestion ||
      landSrc?.pressReleaseDetails?.hasSuggestion ||
      landSrc?.additionalDetails?.hasSuggestion ||
      "";

    const pressReleaseFee =
      formSrc?.pressReleaseFee ||
      formSrc?.pressDetails?.pressReleaseFee ||
      formSrc?.pressReleaseDetails?.pressReleaseFee ||
      landSrc?.pressReleaseFee ||
      landSrc?.pressReleaseAmount ||
      landSrc?.pressDetails?.pressReleaseFee ||
      landSrc?.pressReleaseDetails?.pressReleaseFee ||
      landSrc?.additionalDetails?.pressReleaseFee ||
      "";

    const invitationRemark =
      formSrc?.invitationRemark ||
      formSrc?.pressDetails?.invitationRemark ||
      formSrc?.pressReleaseDetails?.invitationRemark ||
      landSrc?.invitationRemark ||
      landSrc?.pressDetails?.invitationRemark ||
      landSrc?.pressReleaseDetails?.invitationRemark ||
      landSrc?.additionalDetails?.invitationRemark ||
      "";

    return {
      hasSuggestion,
      pressReleaseFee,
      invitationRemark,
    };
  };

  const initialValues = extractValues(formData, landUseData);

  const { control, handleSubmit, watch, reset } = useForm({
    defaultValues: initialValues,
  });

  useEffect(() => {
    reset(extractValues(formData, landUseData));
  }, [formData, landUseData, reset]);

  const watchSuggestion = watch("hasSuggestion");

  const onSubmit = (data) => {
    console.log("Invitation Suggestion Data:", data);

    const pressDetailsData = {
      ...(formData?.pressDetails || {}),
      ...(formData?.pressReleaseDetails || {}),
      hasSuggestion: data.hasSuggestion,
      pressReleaseFee: data.pressReleaseFee,
      invitationRemark: data.invitationRemark,
    };

    onSaveClick({
      hasSuggestion: data.hasSuggestion,
      pressReleaseFee: data.pressReleaseFee,
      invitationRemark: data.invitationRemark,
      pressDetails: pressDetailsData,
      pressReleaseDetails: pressDetailsData,
    });
  };

  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Invitation Suggestion</h2>
          </div>

          <Container className="formInputContainer common-app-form px-4" fluid>
            {/* Radio Button */}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  name="hasSuggestion"
                  label="Any objections or suggestions required for this proposal?"
                  type="radioButton"
                  data={yesOrNo}
                  mandatory
                />
              </Col>
            </Row>

            {/* Amount Field (Conditional) */}
            {watchSuggestion === "yes" && (
              <Row>
                <Col md={4}>
                  <InputWrapper
                    control={control}
                    name="pressReleaseFee"
                    label="Press Release Fee (Amount)"
                    placeholder="Enter Amount"
                    type="number"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "Amount is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}

            {watchSuggestion && (
              <Row>
                <Col md={4} style={{ marginTop: "15px" }}>
                  <Controller
                    name="invitationRemark"
                    control={control}
                    rules={{
                      required: "This field is required",
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        label="Remark"
                        placeholder="Please enter Remark"
                        multiline
                        rows={4}
                        fullWidth
                        error={!!error}
                        helperText={error?.message}
                      />
                    )}
                  />
                </Col>
              </Row>
            )}
          </Container>

          {/* Footer */}

          <div className="footerContainer2">
            <div className="buttonWrapper">
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" />
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};

export default InvitationSuggestion;


